import React from 'react';
import { Field, reduxForm } from 'redux-form/immutable';
import PropTypes from 'prop-types';
import NavbarModulo from '../../components/NavbarModulo';

import {
  renderField,
} from "../../Utils/renderField/renderField";

function TipoManoObraForm(props) {
  const { handleSubmit, crear, modulo } = props;
  const editar = window.location.href.includes('editar');
  let titulo = editar ? 'Modificar mano de obra' : 'Crear mano de obra';
  let disabled = false;
  if (crear === false && editar === false) {
    disabled = true;
    titulo = 'Ver mano de obra'
  }
  
  let autoFocus = true;
  let ruta = window.location.href;
  let id_emp = ruta.split('/');
  return (
    <div>
      <NavbarModulo
        modulo={modulo}
        titulo={titulo}
      />
      <br />
      <div className="mb-4 card card-small text-white bg-dark mb-3">
        <div className="p-0 pt-3 d-flex flex-column flex-md-row">
          <div className="d-flex flex-column flex-1 mx-4">
            <div className='row'>
              <div className='col-5'>
                <Field
                  autoFocus={autoFocus}
                  name="descripcion"
                  placeholder="Nombre"
                  className="form-control"
                  component={renderField}
                  disabled={disabled}
                  msj="Nombre"
                />
              </div>
            </div>
            <div className='d-flex flex-row mt-3'>
              {disabled == false &&
                <button
                  className='btn mr-2 mb-3 btn-primary'
                  onClick={handleSubmit}
                >
                  {editar ? 'Modificar' : 'Guardar'}
                </button>
              }
              <a
                href={`/#/gestion_proyecto/${id_emp[5]}/tipo_mano_obra`}
                className='btn btn-secondary mb-3'
              >
                Regresar
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

TipoManoObraForm.propTypes = {
  handleSubmit: PropTypes.func,
  crear: PropTypes.bool,
  modulo: PropTypes.object,
};

export default reduxForm({
  form: 'FormTipoManoObra',
})(TipoManoObraForm);
